import React from 'react';
import styles from './responsive-settings.module.scss';

const ResponsiveSettings = ({ setGifSize, gifSize }) => {
  const onWidthChange = value => {
    setGifSize({
      width: value,
      height: Math.round(value / (16 / 9)),
    });
  };

  const onHeightChange = value => {
    setGifSize({
      width: Math.round(value * (16 / 9)),
      height: value,
    });
  };

  return (
    <div className={styles.wrapper}>
      <input type="number" value={gifSize.width} onChange={e => onWidthChange(e.target.value)} />
      <span>x</span>
      <input type="number" value={gifSize.height} onChange={e => onHeightChange(e.target.value)} />
      <span>Pixels</span>
    </div>
  );
};

export default ResponsiveSettings;
